'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationRefresh = function NavigationRefresh(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z' })
  );
};
NavigationRefresh = (0, _pure2.default)(NavigationRefresh);
NavigationRefresh.displayName = 'NavigationRefresh';
NavigationRefresh.muiName = 'SvgIcon';

exports.default = NavigationRefresh;


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/svg-icons/navigation/refresh.js
 ** module id = 807
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/svg-icons/navigation/refresh.js
 ** module id = 807
 ** module chunks = 1
 **/